import { useEffect } from "react";

const useKeyboardShortcut = (key: string, handleClick: () => void) => {
	useEffect(() => {
		const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

		const keydownListener = (event: KeyboardEvent) => {
			const isKeyPressed =
				(isMac && event.metaKey && event.key === key) ||
				(!isMac && event.ctrlKey && event.key === key);

			if (isKeyPressed) {
				event.preventDefault();
				handleClick();
			}
		};
		window.addEventListener("keydown", keydownListener);

		return () => {
			window.removeEventListener("keydown", keydownListener);
		};
	}, [handleClick, key]);

	return null;
};

export default useKeyboardShortcut;
